import * as v from "valibot";
export const EnvSchema = v.object({
    // Database
    DB_URL: v.optional(v.pipe(v.string(), v.url())),
    DB_AUTH_TOKEN: v.optional(v.string()),
    // Speech Providers
    SPEECH_PROVIDER: v.optional(v.picklist(["google", "whisper", "azure", "aws"]), "google"),
    GOOGLE_SPEECH_API_KEY: v.optional(v.string()),
    GOOGLE_TTS_API_KEY: v.optional(v.string()),
    WHISPER_SPEECH_API_KEY: v.optional(v.string()),
    SPEECH_API_KEY: v.optional(v.string()), // Fallback generic key
    // LLM Providers
    CF_AIG_API_KEY: v.optional(v.string()),
    CF_AIG_BASE_URL: v.optional(v.pipe(v.string(), v.url())),
    CF_AIG_PRIMARY_MODEL: v.optional(v.string()),
    CF_AIG_FALLBACK_MODEL: v.optional(v.string()),
    AI_GATEWAY_API_KEY: v.optional(v.string()),
    AI_GATEWAY_BASE_URL: v.optional(v.pipe(v.string(), v.url())),
    AI_GATEWAY_PRIMARY_MODEL: v.optional(v.string()),
    AI_GATEWAY_FALLBACK_MODEL: v.optional(v.string()),
    // App Config
    NODE_ENV: v.optional(v.picklist(["development", "production", "test"]), "development"),
    LOG_LEVEL: v.optional(v.picklist(["debug", "info", "warn", "error"]), "info"),
    // Auth (better-auth)
    AUTH_SECRET: v.optional(v.string()),
    AUTH_URL: v.optional(v.pipe(v.string(), v.url())),
    DEV_BYPASS_AUTH: v.optional(v.string()),
    DEV_BYPASS_AUTH_EMAIL: v.optional(v.string()),
    DEV_AUTO_LOGIN_EMAIL: v.optional(v.string()),
    ALLOW_PROD_AUTO_LOGIN: v.optional(v.string()),
    // Observability
    SENTRY_DSN: v.optional(v.string()),
    SENTRY_TRACES_SAMPLE_RATE: v.optional(v.string()),
    // Upstash (Redis)
    UPSTASH_REDIS_REST_URL: v.optional(v.pipe(v.string(), v.url())),
    UPSTASH_REDIS_REST_TOKEN: v.optional(v.string()),
    UPSTASH_REDIS_REST_READ_ONLY_TOKEN: v.optional(v.string()),
    // R2
    R2_BUCKET: v.optional(v.string()),
    R2_PUBLIC_BASE_URL: v.optional(v.pipe(v.string(), v.url())),
});
